import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from '@xstate/react';
import {
  isLoading as isLoadingSelector,
  isSaving as isSavingSelector,
  StepEvents,
  log,
} from '@bingads-webui-campaign-react/step-wizard-machine';
import { useIsMounted } from './use-is-mounted';

/**
 * A step repository React component for steps that neither load, nor save any data.
 * @param {Object} props the component's props
 * @param {Object} props.stepService an instance of the step's state machine
 * @returns {Element} an empty VDOM
 */
export const NoDataStepRepository = ({ stepService }) => {
  const isMountedRef = useIsMounted();

  const isLoading = useSelector(stepService, isLoadingSelector);
  const isSaving = useSelector(stepService, isSavingSelector);

  useEffect(() => {
    if (isLoading) {
      log('NoDataStepRepository loading data with loadData');
      if (isMountedRef.current) {
        log('NoDataStepRepository sending DONE_LOADING');
        stepService.send({ type: StepEvents.DONE_LOADING, data: {} });
      }
    } else if (isSaving) {
      log('NoDataStepRepository saving data with saveData');
      if (isMountedRef.current) {
        log('NoDataStepRepository sending DONE_SAVING');
        stepService.send({ type: StepEvents.DONE_SAVING, data: {} });
      }
    }
  }, [stepService, isLoading, isSaving, isMountedRef]);

  log('NoDataStepRepository.render: isLoading=_, isSaving=_', isLoading, isSaving);

  return null;
};

NoDataStepRepository.propTypes = {
  stepService: PropTypes.shape({
    subscribe: PropTypes.func.isRequired,
    send: PropTypes.func,
  }).isRequired,
};
